module.exports = __webpack_public_path__ + "static/media/Home_Icon5.356ba2b2.png";